/**
 * Maps STC suggested reasons (from pre-emptive detection) to Special Service codes
 * used in the STC form dropdown. Matches backend stcPhrases labels to form codes.
 */
const REASON_PATTERNS: { pattern: RegExp | string; code: string }[] = [
  { pattern: /nebuliser|nebulizer|asthmatic attack/i, code: 'K' },
  { pattern: /suturing|laceration|tissue glue/i, code: 'B' },
  { pattern: /larc coil fitting|coil fitting/i, code: 'CH' },
  { pattern: /larc implant fitting|implant fitting/i, code: 'CG' },
  { pattern: /coil removal|larc coil removal/i, code: 'CJ' },
  { pattern: /implant removal|larc implant removal/i, code: 'CI' },
  { pattern: /larc counselling|larc - counselling|follow up.*larc/i, code: 'AB' },
  { pattern: /larc device|larc coil|larc implant|larc\b/i, code: 'AB' },
  { pattern: /foreign body.*eye|adherent.*eye/i, code: 'H' },
  { pattern: /foreign bod(y|ies)|lodged.*ear|impacted/i, code: 'J' },
  { pattern: /phlebotomy|haemochromatosis|hemochromatosis/i, code: 'AL' },
  { pattern: /excisions|cryotherapy|diathermy|skin lesions/i, code: 'A' },
  { pattern: /abpm|ambulatory blood pressure/i, code: 'AD' },
  { pattern: /ecg|electrocardiogram/i, code: 'F' },
  { pattern: /bladder catheter|catheterization/i, code: 'L' },
  { pattern: /case conference|hse convened/i, code: 'M' },
  { pattern: /abscess|draining abscess/i, code: 'Z' },
  { pattern: /dental haemorrhage|nasal haemorrhage|haemorrhage/i, code: 'D' },
  { pattern: /contraception consultation/i, code: 'CF' },
]

/**
 * Map stcSuggestedReasons from an appointment to a single Special Service code
 * for pre-filling the STC form. Returns '0' (Please Select) if no match.
 */
export function mapStcReasonsToSpecialServiceCode(reasons: string[] | undefined): string {
  if (!reasons?.length) return '0'
  const combined = reasons.join(' ').toLowerCase()
  for (const { pattern, code } of REASON_PATTERNS) {
    const re = typeof pattern === 'string' ? new RegExp(pattern, 'i') : pattern
    if (re.test(combined)) return code
  }
  return '0'
}
